<template>
  <DownArrow />
</template>

<script>
import DownArrow from './down-arrow.svg';
export default {
  components: {
    DownArrow,
  },
};
</script>

<style lang="scss" scoped>
svg {
  width: 1rem;
  fill: $color-icon;
  margin: 0 auto;
}
</style>
